import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CocaColaValuesGameComponent } from './coca-cola-values-game.component';

const routes: Routes = [
  {
    path: '',
    component: CocaColaValuesGameComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CocaColaValuesGameRoutingModule {}
